import * as React from "react";


interface SwitchProps{
    active: boolean;
    setActive?: Function;
    left: string;
    right: string;
}

export function Switch(props: SwitchProps) {

    return <>
        <div className="key-type-switch">
            <div className={`${!props.active && "active"} key-type-button left`} onClick={()=>props.setActive && props.setActive(false)}>{props.left}</div>
            <div className={`${props.active && "active"} key-type-button right`} onClick={()=>props.setActive && props.setActive(true)}>{props.right}</div>
        </div>
        <style jsx>
            {`
                .key-type-switch{
                    display: flex;
                    height:40px;
                    border-radius: 4px;
                    cursor:pointer;
                    transition-property: all;
                    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                    transition-duration: 150ms; 
                    font-weight:var(--font-weight-bold);
                    font-size: var(--font-size-3);
                    line-height: 1;
                    outline: none;
                    align-items:center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    user-select: none;
                    letter-spacing: -0.2px;
                    position:relative;
                }
                .key-type-button{
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    flex:1;
                    width:100%;
                    height:100%;
                    padding:5px 15px;
                    border-bottom:1px solid var(--border-color);
                    border-top:1px solid var(--border-color);
                    background:white;
                }
                .key-type-button:hover{
                    cursor:pointer;
                }
                .right{
                    border-top-right-radius:var(--border-radius);
                    border-bottom-right-radius:var(--border-radius);
                    border-right:1px solid var(--border-color);
                }
                .right:hover:not(.active){
                    color:var(--pink);
                }
                .left{
                    border-top-left-radius:var(--border-radius);
                    border-bottom-left-radius:var(--border-radius);
                    border-left:1px solid var(--border-color);
                }
                .left:hover:not(.active){
                    color:var(--pink);
                }
                .active{
                    background:var(--pink);
                    color:white;
                    border-color:var(--pink);
                }
            
            `}
        </style>
    </>;
}
